<template>
    <v-card>
        <v-form
            ref="entityForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="statuses"
                                :rules="[requiredRule]"
                                clearable
                                item-text="name"
                                item-value="value"
                                label="Status"
                                v-model="entity.accisureFormStatus"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <h4>
                                Representative: {{entity.representativeName}}
                                <br />
                                Product: {{entity.representativeProductName}}
                                <br />
                                Subscription: {{entity.subscriptionName}}
                                <br />
                                Dependants: {{entity.subscriptionDependantsCount}}
                                <br />
                                Amount: R{{entity.subscriptionAmount.toFixed(2)}}
                                <br />
                                Submitted At: {{entity.createdAt}}
                            </h4>
                        </v-col>

                        <v-col cols="12">
                            <h4>Main Member:</h4>
                            <v-text-field
                                :disabled="isLoading"
                                label="Titles"
                                readonly
                                v-model="entity.titles"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Initials"
                                readonly
                                v-model="entity.initials"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Surname"
                                readonly
                                v-model="entity.surname"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="genders"
                                clearable
                                item-text="name"
                                item-value="value"
                                label="Gender"
                                readonly
                                v-model="entity.gender"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Identity Number"
                                readonly
                                v-model="entity.identityNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Cell Number"
                                readonly
                                v-model="entity.cellNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Work Number"
                                readonly
                                v-model="entity.workNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Email"
                                readonly
                                v-model="entity.email"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Address"
                                readonly
                                v-model="entity.address"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="City"
                                readonly
                                v-model="entity.city"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Postal Address"
                                readonly
                                v-model="entity.postalAddress"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Postal Code"
                                readonly
                                v-model="entity.postalCode"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Allergies"
                                readonly
                                v-model="entity.allergies"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Bank Account Number"
                                readonly
                                v-model="entity.bankAccountNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Bank Name"
                                readonly
                                v-model="entity.bankName"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Bank Branch Code"
                                readonly
                                v-model="entity.bankBranchCode"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="accisureDebitOrderDates"
                                clearable
                                item-text="name"
                                item-value="value"
                                label="Debit Order Date"
                                readonly
                                v-model="entity.accisureDebitOrderDate"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                label="Commencement Date"
                                readonly
                                v-model="entity.commencementDate"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <div>Signature</div>
                            <v-img
                                :src="entity.signatureImageBase64"
                                contain
                                max-height="200px"
                                max-width="100%"
                            ></v-img>
                        </v-col>

                        <template v-if="entity.subscriptionDependantsCount>0">
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>

                            <v-col cols="12">
                                <h4>Dependant 1:</h4>
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Initials"
                                    readonly
                                    v-model="entity.dependant1Initials"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Surname"
                                    readonly
                                    v-model="entity.dependant1Surname"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading"
                                    :items="genders"
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    label="Gender"
                                    readonly
                                    v-model="entity.dependant1Gender"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Identity Number"
                                    readonly
                                    v-model="entity.dependant1IdentityNumber"
                                ></v-text-field>
                            </v-col>
                        </template>
                        <template v-if="entity.subscriptionDependantsCount>1">
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>

                            <v-col cols="12">
                                <h4>Dependant 2:</h4>
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Initials"
                                    readonly
                                    v-model="entity.dependant2Initials"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Surname"
                                    readonly
                                    v-model="entity.dependant2Surname"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading"
                                    :items="genders"
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    label="Gender"
                                    readonly
                                    v-model="entity.dependant2Gender"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Identity Number"
                                    readonly
                                    v-model="entity.dependant2IdentityNumber"
                                ></v-text-field>
                            </v-col>
                        </template>

                        <template v-if="entity.subscriptionDependantsCount>2">
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>

                            <v-col cols="12">
                                <h4>Dependant 3:</h4>
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Initials"
                                    readonly
                                    v-model="entity.dependant3Initials"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Surname"
                                    readonly
                                    v-model="entity.dependant3Surname"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading"
                                    :items="genders"
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    label="Gender"
                                    readonly
                                    v-model="entity.dependant3Gender"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Identity Number"
                                    readonly
                                    v-model="entity.dependant3IdentityNumber"
                                ></v-text-field>
                            </v-col>
                        </template>
                        <template v-if="entity.subscriptionDependantsCount>3">
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>

                            <v-col cols="12">
                                <h4>Dependant 4:</h4>
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Initials"
                                    readonly
                                    v-model="entity.dependant4Initials"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Surname"
                                    readonly
                                    v-model="entity.dependant4Surname"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading"
                                    :items="genders"
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    label="Gender"
                                    readonly
                                    v-model="entity.dependant4Gender"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Identity Number"
                                    readonly
                                    v-model="entity.dependant4IdentityNumber"
                                ></v-text-field>
                            </v-col>
                        </template>
                        <template v-if="entity.subscriptionDependantsCount>4">
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>

                            <v-col cols="12">
                                <h4>Dependant 5:</h4>
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Initials"
                                    readonly
                                    v-model="entity.dependant5Initials"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Surname"
                                    readonly
                                    v-model="entity.dependant5Surname"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading"
                                    :items="genders"
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    label="Gender"
                                    readonly
                                    v-model="entity.dependant5Gender"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="Identity Number"
                                    readonly
                                    v-model="entity.dependant5IdentityNumber"
                                ></v-text-field>
                            </v-col>
                        </template>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="entity.id > 0"
                        >Delete</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >{{entity.id > 0 ? "Update" : "Add"}}</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import SubscribeFormSubmission from "../../models/SubscribeFormSubmission.model";
export default {
    props: {
        entityIn: SubscribeFormSubmission
    },
    components: {
        //
    },
    data() {
        return {
            statuses: [
                { name: "Unattended", value: 1 },
                { name: "Accepted", value: 2 },
                { name: "Rejected", value: 3 }
            ],
            accisureDebitOrderDates: [
                { name: "1st", value: 1 },
                { name: "16th", value: 16 },
                { name: "26th", value: 26 }
            ],
            genders: [
                { name: "Female", value: 2 },
                { name: "Male", value: 1 }
            ],
            entity: new SubscribeFormSubmission().set(this.entityIn),
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedEntity) {
            this.$emit("saved", savedEntity);
        },
        emitDeletedEntity(deletedEntity) {
            this.$emit("deleted", deletedEntity);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.$refs.entityForm.validate();
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            this.validateForm();
            if (this.isValid) {
                this.isLoading = true;
                this.isSaving = true;

                this.$store
                    .dispatch(
                        "subscribeFormSubmissions/" +
                            (this.entity.id == 0 ? "create" : "update"),
                        this.entity
                    )
                    .then(
                        entityWithInfo => {
                            this.notify("Successfully saved.", "success");
                            if (this.entity.id == 0) {
                                this.entity.id = entityWithInfo.entity.id;
                            }
                            this.emitSavedEntity(entityWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm("Are you sure you want to delete this?");
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("subscribeFormSubmissions/delete", this.entity.id)
                    .then(
                        () => {
                            this.notify("Successfully deleted.", "success");
                            this.emitDeletedEntity(this.entity);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>